import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabC as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabC = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const hispanicLatinoField = () => {
    const propertyName = pn<AprResponseModel>("hispanicLatino");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.hispanicLatino} {formatPercentTotal(props.data?.hispanicLatino, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const americanIndianField = () => {
    const propertyName = pn<AprResponseModel>("americanIndian");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.americanIndian} {formatPercentTotal(props.data?.americanIndian, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const asianField = () => {
    const propertyName = pn<AprResponseModel>("asian");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.asian} {formatPercentTotal(props.data?.asian, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const africanAmericanField = () => {
    const propertyName = pn<AprResponseModel>("africanAmerican");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.africanAmerican} {formatPercentTotal(props.data?.africanAmerican, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const whiteField = () => {
    const propertyName = pn<AprResponseModel>("white");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.white} {formatPercentTotal(props.data?.white, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const pacificIslanderField = () => {
    const propertyName = pn<AprResponseModel>("pacificIslander");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.pacificIslander} {formatPercentTotal(props.data?.pacificIslander, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const twoRacesField = () => {
    const propertyName = pn<AprResponseModel>("twoRaces");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.twoRaces} {formatPercentTotal(props.data?.twoRaces, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownField = () => {
    const propertyName = pn<AprResponseModel>("unknown");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknown} {formatPercentTotal(props.data?.unknown, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participant Distribution by Race and Ethnicity</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {hispanicLatinoField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {americanIndianField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {asianField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {africanAmericanField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {whiteField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {pacificIslanderField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {twoRacesField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {unknownField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={9}>
            <PieChart 
              id="pie-tab-c"
              dataSource={props.data?.chartValues} 
              palette="Bright" 
              title="Participants" 
              width="100%"
              size={{ width: 1200, height: 700 }} // Increase chart size
              >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>

              <Legend
                verticalAlignment="top" // Position the legend at the top
                // iconType="line" // Optional: Set legend icon type to line
                // payloadFormatter={(entry) => `${entry.data.label} - ${entry.value}`} // Format legend text
              />

              {/* <Size width="100%" /> */}
              {/* <Export enabled={true} /> */}
            </PieChart>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
